<template>
  <div class="container-xxl py-24">
    <MetaTags
      title="Вакансии от разных компаний: Поиск через видеорезюме"
      description="Ищете компанию для работы? На нашей платформе вы найдете разнообразные компании, предлагающие видеовакансии в различных отраслях. Найдите идеального работодателя уже сегодня."
    />
    <AppBreadcrumbs
      :links="[
        {
          text: 'Компании'
        }
      ]"
    />
    <h1 class="fw-bold">
      Компании
    </h1>
    <div class="d-flex justify-content-between align-items-center py-12">
      <div class="d-flex flex-md-row flex-column align-items-center mb-0">
        <span>
          Найдено <span class="text-primary fw-bold">{{ itemsCount }}</span> <span class="d-md-inline-block d-none">компаний работодателей</span>
        </span>
      </div>
      <div class="gap-10 d-flex col-md-7 col-sm-9 col-lg-auto justify-content-end col-auto">
        <div class="form-search d-sm-flex align-items-center d-none position-relative">
          <input
            v-model="companyName"
            class="form-control border border-alice-blue"
            style="background-image: none"
            type="search"
            placeholder="Название компании"
            aria-label="Search"
            @input="onSearch"
          >
          <svg
            height="30"
            width="30"
            class="text-gray position-absolute"
            style="right: 20px"
          >
            <use xlink:href="/public/icons/main.svg#search" />
          </svg>
        </div>
        <button class="btn d-none d-flex align-items-center fw-medium text-dark py-12 px-md-24 px-8 border border-1 border-platinum rounded-pill shadow-none">
          Сортировка
          <svg
            width="20"
            height="11"
            viewBox="0 0 20 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-inject-url="https://peterdraw.studio/ziro-html/assets/icons/chevron-down.svg"
            class="svg-inject text-primary is-20 ms-15"
          >
            <path d="M19.6273 1.77879L10.6273 9.77878C10.4448 9.9391 10.2102 10.0275 9.96728 10.0275C9.72437 10.0275 9.48977 9.9391 9.30728 9.77878L0.307278 1.77879C0.121445 1.6003 0.0116842 1.35696 0.000880246 1.09952C-0.00992376 0.842077 0.0790634 0.5904 0.249287 0.396964C0.419511 0.203528 0.657833 0.0832638 0.91456 0.0612484C1.17129 0.039233 1.42661 0.117165 1.62728 0.278796L9.96728 7.68878L18.3073 0.278796C18.4046 0.185284 18.5199 0.112452 18.6462 0.0646883C18.7724 0.0169249 18.9071 -0.00478066 19.0419 0.000879482C19.1768 0.00653962 19.3091 0.0394483 19.4309 0.0976224C19.5528 0.155797 19.6615 0.238031 19.7507 0.339371C19.8399 0.440711 19.9076 0.559058 19.9498 0.687279C19.9921 0.8155 20.0079 0.950941 19.9963 1.08544C19.9848 1.21994 19.9462 1.35071 19.8827 1.46987C19.8193 1.58903 19.7324 1.69412 19.6273 1.77879Z" />
          </svg>
        </button>
        <button
          class="btn btn-rounded border border-1 border-platinum shadow-none d-none"
          role="button"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-inject-url="https://peterdraw.studio/ziro-html/assets/icons/filter.svg"
            class="svg-inject svg-icon text-primary"
          >
            <path d="M1 4H12C12 4.53043 12.2107 5.03914 12.5858 5.41421C12.9609 5.78929 13.4696 6 14 6H16C16.5304 6 17.0391 5.78929 17.4142 5.41421C17.7893 5.03914 18 4.53043 18 4H19C19.2652 4 19.5196 3.89464 19.7071 3.70711C19.8946 3.51957 20 3.26522 20 3C20 2.73478 19.8946 2.48043 19.7071 2.29289C19.5196 2.10536 19.2652 2 19 2H18C18 1.46957 17.7893 0.960859 17.4142 0.585786C17.0391 0.210714 16.5304 0 16 0H14C13.4696 0 12.9609 0.210714 12.5858 0.585786C12.2107 0.960859 12 1.46957 12 2H1C0.734784 2 0.48043 2.10536 0.292893 2.29289C0.105357 2.48043 0 2.73478 0 3C0 3.26522 0.105357 3.51957 0.292893 3.70711C0.48043 3.89464 0.734784 4 1 4V4ZM14 2H16V3V4H14V2ZM19 9H10C10 8.46957 9.78929 7.96086 9.41421 7.58579C9.03914 7.21071 8.53043 7 8 7H6C5.46957 7 4.96086 7.21071 4.58579 7.58579C4.21071 7.96086 4 8.46957 4 9H1C0.734784 9 0.48043 9.10536 0.292893 9.29289C0.105357 9.48043 0 9.73478 0 10C0 10.2652 0.105357 10.5196 0.292893 10.7071C0.48043 10.8946 0.734784 11 1 11H4C4 11.5304 4.21071 12.0391 4.58579 12.4142C4.96086 12.7893 5.46957 13 6 13H8C8.53043 13 9.03914 12.7893 9.41421 12.4142C9.78929 12.0391 10 11.5304 10 11H19C19.2652 11 19.5196 10.8946 19.7071 10.7071C19.8946 10.5196 20 10.2652 20 10C20 9.73478 19.8946 9.48043 19.7071 9.29289C19.5196 9.10536 19.2652 9 19 9ZM6 11V9H8V10V11H6ZM19 16H16C16 15.4696 15.7893 14.9609 15.4142 14.5858C15.0391 14.2107 14.5304 14 14 14H12C11.4696 14 10.9609 14.2107 10.5858 14.5858C10.2107 14.9609 10 15.4696 10 16H1C0.734784 16 0.48043 16.1054 0.292893 16.2929C0.105357 16.4804 0 16.7348 0 17C0 17.2652 0.105357 17.5196 0.292893 17.7071C0.48043 17.8946 0.734784 18 1 18H10C10 18.5304 10.2107 19.0391 10.5858 19.4142C10.9609 19.7893 11.4696 20 12 20H14C14.5304 20 15.0391 19.7893 15.4142 19.4142C15.7893 19.0391 16 18.5304 16 18H19C19.2652 18 19.5196 17.8946 19.7071 17.7071C19.8946 17.5196 20 17.2652 20 17C20 16.7348 19.8946 16.4804 19.7071 16.2929C19.5196 16.1054 19.2652 16 19 16ZM12 18V16H14V17V18H12Z" />
          </svg>
        </button>
      </div>
    </div>
    <div class="form-search d-sm-none align-items-center d-flex position-relative">
      <input
        v-model="companyName"
        class="form-control border border-alice-blue"
        style="background-image: none"
        type="search"
        placeholder="Название компании"
        aria-label="Search"
        @input="onSearch"
      >
      <svg
        height="30"
        width="30"
        class="text-gray position-absolute"
        style="right: 20px"
      >
        <use xlink:href="/public/icons/main.svg#search" />
      </svg>
    </div>
    <AppLoader
      :is-hide="!loading"
      class="w-100"
    />
    <div
      v-show="!loading"
      class="row mb-34 mt-25"
    >
      <div
        v-for="company in companies.items"
        class="col-12 col-md-6 mb-20 col-lg-4"
      >
        <CompanySearchItem
          :id="company.id"
          :title="company.name"
          :img="company.logo"
          :time="new Date(company.created * 1000)"
          :count-vacancy="company.countVacancy"
          :type-company="company.type === 1 ? 'Работодатель' : 'агентство'"
        />
      </div>
    </div>
    <PaginationComponent
      :per-page="perPage"
      :items-count="itemsCount"
      @change-page="getCompanies"
    />
    <VacancyCarousel
      title="Последние вакансии"
      :vacancies="vacancies"
      @response="setResponse"
      @add-favorite="addFavorite"
      @remove-favorite="removeFavorite"
    />
  </div>
</template>

<script setup lang="ts">
import type { Company } from "~/entities/company";
import type { Vacancy } from "~/entities/vacancy";
import CompanySearchItem from "~/components/CompanySearch/CompanySearchItem.vue";
import debounce from 'lodash/debounce';
import MetaTags from "~/components/meta/MetaTags.vue";

const route = useRoute();
const router = useRouter();

//-----TYPES-----\\
type CompaniesResponse = {
  items: [];
  count: number
};
type VacancySearch = Vacancy & { company: Company; response: { id: string }|null };
type VacanciesResponse = {
  items: VacancySearch[];
  count: number
};

//-----VARIABLES-----\\
const perPage = 12;

//-----STATE-----\\
const page = ref<number>(route.query.page??1);
const itemsCount = ref<number>(0);
const companies = ref<CompaniesResponse>({ items: [], count: 0 });
const vacancies = ref<VacanciesResponse>({ items: [], count: 0 });
const companyName = ref('');
const loading = ref<boolean>(false);

//-----ASYNC-----\\
const { data } = await mainFetch('vacancies', {
  query: {
    type: 'search'
  }
});

vacancies.value = data.value.vacancies;
await getCompanies();

//-----METHODS-----\\
const search = debounce(searchCompanies, 350);
function onSearch() {
  if (companyName.value.length < 3 && companyName.value.length > 0) {
    search.cancel();
    return;
  }
  search();
}
async function getCompanies(newPage: number|null = null){
  loading.value = true;
  if (newPage !== null) {
    page.value = newPage;
  }

  const { data } = await mainFetch('companies', {
    query: {
      name: companyName.value,
      perPage,
      page: newPage??route.query.page
    }
  });

  companies.value = data.value.companies;
  itemsCount.value = data.value.companies.count;
  loading.value = false;
}
async function searchCompanies() {
  const getParams = [];
  for (const key in route.query) {
    if (key !== 'page') {
      getParams.push(key + '=' + route.query[key]);
    } else {
      getParams.push('page=1');
    }
  }

  router.push(route.path + '?' + getParams.join('&'));
  await getCompanies(1);
}
function setResponse(index: number, responseId: string) {
  vacancies.value.items[index].response = { id: responseId };
}
function addFavorite(index: number, favoriteId: string) {
  vacancies.value.items[index].favorite = { id: favoriteId };
}
function removeFavorite(index: number) {
  vacancies.value.items[index].favorite = null;
}

</script>